import validator from 'validator';
declare var jQuery:any;

interface fieldData {
    name:string,
    type:string,
    required:boolean,
    input_type:string,
    value:any,
}

interface fieldArr {
    [key:string]: fieldData;
}

interface formValueData {
    action:string,
    fields: fieldArr
}

interface localize {
    admin_ajax:string,
    admin_post:string,
}

declare var register_localize:localize;

// FIXME: This file is loaded for every WP page but the restriction before calling init() is wrong. It's causing un-predictable behavior.
// We should identify where this is using and cleanup this PlatformRegisterDeprecated class. At least, it is affecting to the "organization_register.php" page
class PlatformRegisterDeprecated {
    public static register_form_id:string='form.register';
    public sections:Array<any>=[];

    constructor() {
    }

    set_section = (currIndex:number, nextIndex:number ) => {
        var currSection = jQuery( `section[data-register-section][data-register-section='${currIndex}']`);
        if( currSection ) {
            currSection.removeClass("active--section");
            currSection.addClass("hidden");
        }

        var nextSection = jQuery(`section[data-register-section][data-register-section='${nextIndex}']`);
        if( nextSection ) {
            nextSection.addClass("active--section");
            nextSection.removeClass("hidden");
        }
    }

    toggle_section = (currIndex:number) => {
        var currSection = jQuery( `section[data-register-section][data-register-section='${currIndex}']`);
        if( currSection ) {
            currSection.removeClass("active--section");
            currSection.addClass("hidden");
        }
    }

    toggle_loader = (toggle:boolean=true) => {
        var loader = jQuery( `${PlatformRegisterDeprecated.register_form_id} section[data-register-loader]`);
        if( loader ) {
            loader.removeClass('show--loader');
            if( toggle ) {
                loader.addClass('show--loader');
            }
        }
    }

    init = () => {
        // NOTIC: On registration page, this PlatformRegisterDeprecated is completely replace by PlatformRegister.
        // So, check the form and terminate the all processes.
        if (jQuery('form.register-unique').length > 0 || jQuery('form.alt_register').length > 0 || jQuery('form.register-organization').length > 0) {
            return;
        }

        jQuery( `section[data-register-section]`).each( (index:number, section:any) => {
            if( section ) {
                const sectionID = jQuery(section).data('section');
                const sectionIndex = jQuery(section).data('register-section');

                this.sections[sectionID] = {
                    'section': sectionID,
                    'sectionIndex': sectionIndex,
                    'validated': false,
                };
            }
        } );

        jQuery(`button[data-vm-action='next'], input[data-vm-action='next']`).on('click', async (e: any) => {
            var nextIndex = 0;
            var currIndex = 0;

            var button = jQuery(e.target);
            var curr_section = button.data('section');
            currIndex = this.sections[curr_section].sectionIndex;

            jQuery('#' + curr_section).submit();

            if (curr_section === 'primary_section') {                                
                if (this.sections.hasOwnProperty(curr_section)) {
                    currIndex = this.sections[curr_section].sectionIndex;

                    if (!this.sections[curr_section].validated) {
                        const validated = await this.validate(curr_section);

                        if (!validated) return;
                        this.sections[curr_section].validated = true;
                        nextIndex += this.sections[curr_section].sectionIndex + 1;
                    } else {
                        nextIndex += this.sections[curr_section].sectionIndex + 1;
                    }
                    const self = this;
                    // Set a timeout to allow other validation logic to run first
                    setTimeout(function() {
                        if (jQuery('.woocommerce-password-strength').hasClass('bad') 
                            || jQuery('.woocommerce-password-strength').hasClass('short')) {
                            console.log('Password strength is too weak, not submitting.');
                            return;
                        }
                        // toggle the section
                        self.set_section(currIndex, nextIndex);                        
                    }, 10);                    
                }                
            }
            else {
                const self = this;
                // Set a timeout to allow other validation logic to run first
                setTimeout(function() {
                    if (jQuery('.rwmb-error').filter(function() {
                        const styleAttr = jQuery(this).attr('style');
                        return styleAttr === undefined || styleAttr === '';
                    }).length > 0) {
                        // If there are errors (visible errors with an empty style attribute)
                        console.log('Form has errors, not submitting.');
                        return;
                    } else {
                        nextIndex += self.sections[curr_section].sectionIndex + 1;
                        self.sections[curr_section].validated = true;
                        jQuery( '#rwmb-validation-message' ).remove();
                    }  
                    self.set_section(currIndex, nextIndex);                    
                }, 1000);
            }
            return true;
        });

        jQuery(`button[data-vm-action='submit']`).on('click', async (e: any) => {
            e.preventDefault();
            var currIndex = 0;

            var button = jQuery(e.target);
            var curr_section = button.data('section');
            currIndex = this.sections[curr_section].sectionIndex;
                        
            if (curr_section === 'primary_section') {
                if (this.sections.hasOwnProperty(curr_section)) {
                    currIndex = this.sections[curr_section].sectionIndex;

                    jQuery('.login--inline-loader-overlay').css({
                        'display': 'flex',
                        'align-items': 'center',
                        'justify-content': 'center'
                    }); 
                    jQuery('.login--inline-loader-overlay').show();                    

                    if (!this.sections[curr_section].validated) {
                        const validated = await this.validate(curr_section);

                        if (!validated) {
                            jQuery('.login--inline-loader-overlay').hide();
                            return;                            
                        }
                        this.sections[curr_section].validated = true;

                        const formData: FormData = this.myFormHandler.get_all_field_data();
                        const response = await fetch( register_localize.admin_ajax, {
                            method: 'POST',
                            credentials: 'same-origin',
                            body: formData,
                        } );
            
                        const data = await response.json();

                        if( data && data.hasOwnProperty('success') && data.success ) {

                            if(data.success && data.alertMessage){
                                alert(data.alertMessage);
                            }
                            if( data.success && data.redirect_url ) {
                                window.location.href = data.redirect_url;
                            }
                        }
                        else {
                            var errorMessageDiv = jQuery(`<p style="background: #f8d7da;color: #721c24;border: 2px solid #f5c6cb;padding: 0.8em;">${data.error_message}</p>`);
                            errorMessageDiv.insertBefore(jQuery('form.login_register_wrapper'));

                            jQuery('.login--inline-loader-overlay').hide();
                            this.sections[curr_section].validated = false;
                        }
                    }
                }                            
            }
            else {
                jQuery('#' + curr_section).submit();
            }
            
            return true;            
            
        });

        jQuery(`button[data-vm-action='back']`).on('click', (e: any) => {
            var currIndex = 0;

            var button = jQuery(e.target);
            var curr_section = button.data('section');
            currIndex = this.sections[curr_section].sectionIndex;

            this.set_section(currIndex, currIndex-1);
            let sectionToBack = jQuery( `section[data-register-section][data-register-section='${currIndex-1}']`);
            this.sections[sectionToBack.data('section')].validated = false;
            jQuery( '#rwmb-validation-message' ).remove();
        });        

        var acc = document.querySelectorAll('.multi_registration_forms .accordion');

        acc.forEach(function(accordion) {
            accordion.addEventListener("click", function() {
              this.classList.toggle("active");
              var panel = this.nextElementSibling;
              if (panel instanceof HTMLElement) {
                panel.style.display = panel.style.display === "block" ? "none" : "block";
              }
              // Close other sections
              acc.forEach(function(otherAccordion) {
                if (otherAccordion !== accordion) {
                  var otherPanel = otherAccordion.nextElementSibling;
                  if (otherPanel instanceof HTMLElement) {
                    otherPanel.style.display = "none";
                  }
                }
              });
            });
        });

        jQuery('form.login_register_wrapper.rwmb-form').on('submit', function(event: any) {
            this.myFormHandler.handleSubmit(event);
        }.bind(this));         
    }

    myFormHandler = {
        get_all_field_data: function() {
            var data = new FormData();
            const form = jQuery('.login_register_wrapper');

            if (form.length <= 0) return data;
        
            form.find('input, select, textarea').each(function() {
                const element = jQuery(this);
                const type = element.attr('type');

                if (type === 'checkbox') {
                    data.append(this.name, this.checked ? this.value : '');
                } else if (type === 'radio') {
                    if (this.checked) {
                        data.append(this.name, this.value);
                    }
                } else if (type === 'file') {
                    if (this.files instanceof FileList && this.files.length > 0) {
                        for (const file of this.files) {
                            const fileFieldName = this.name.replace('_file_', '').replace(/\[\]$/, '');
                            data.append(fileFieldName + '[]', file);
                        }
                    }
                } else {
                    data.append(this.name, this.value);
                }
            });
    
            return data;
        },
        
        show_error_message: function (error_message: string ) {
            var forms = jQuery('form.login_register_wrapper .register--sections');
            if (forms.length) {
                jQuery(".registration-error").remove();
                var errorMessageDiv = jQuery(`<p class="registration-error" style="background: #f8d7da;color: #721c24;border: 2px solid #f5c6cb;padding: 0.8em;">${error_message}</p>`);
                errorMessageDiv.insertBefore(forms[0]);
                console.log('forms.length-1 ', forms.length-1)
                var currSection = jQuery( `section[data-register-section][data-register-section='${forms.length-1}']`);
                if( currSection ) {
                    currSection.removeClass("active--section");
                    currSection.addClass("hidden");
                }
        
                var nextSection = jQuery(`section[data-register-section][data-register-section='0']`);
                if( nextSection ) {
                    nextSection.addClass("active--section");
                    nextSection.removeClass("hidden");
                }                
            }
        },
        
        handleSubmit: function(event: any) {
            event.preventDefault();
            
            const self = this;
            
            // Set a timeout to allow other validation logic to run first
            setTimeout(function() {
                // Check if this form is the last form
                if (jQuery(event.target).is(jQuery('form.login_register_wrapper.rwmb-form').last()) && !jQuery(event.target).attr('data-section')) {
                    // Check if there are any visible errors
                    if (jQuery('.rwmb-error').filter(function() {
                        const styleAttr = jQuery(this).attr('style');
                        return styleAttr === undefined || styleAttr === '';
                    }).length > 0) {
                        // If there are visible errors
                        console.log('Form has errors, not submitting.');
                    } else {
                        // If no errors and it's the last form
                        console.log('check here if its already the last page');

                        const formData = self.get_all_field_data();

                        jQuery('.login--inline-loader-overlay').show();
                        jQuery('.login--inline-loader-overlay').css({
                            'display': 'flex',
                            'align-items': 'center',
                            'justify-content': 'center'
                        });                        

                        // Perform AJAX submission
                        jQuery.ajax({
                            type: 'POST',
                            url: register_localize.admin_ajax,
                            data: formData,
                            processData: false, 
                            contentType: false,
                            success: function(response: any) {
                                if(response.success && response.alertMessage){
                                    alert(response.alertMessage);
                                }
                                if (response.success && response.redirect_url) {
                                    window.location.href = response.redirect_url;
                                }
                                else {
                                    self.show_error_message(response.error_message);
                                    jQuery('.login--inline-loader-overlay').hide();
                                }
                            },
                            error: function(error: any) {
                                console.error('Form submission failed:', error);
                                self.show_error_message(error);
                                jQuery('.login--inline-loader-overlay').hide();
                                jQuery( '#rwmb-validation-message' ).remove();                              
                            }
                        });
                    }
                }                
            }, 1000);
        }
    };

    get_field_data = ( section_id:string ) => {
        var field_sections:fieldArr= {};

        jQuery(`${PlatformRegisterDeprecated.register_form_id} [data-section="${section_id}"] [required]`).each((index:number, input_el:any) => {
            if (jQuery(input_el).closest('.rwmb-clone-template').length > 0) {
                // ignore clone template inputs which is not needed to be validated
                return;
            }
            var field_name = jQuery(input_el).attr('name');
            var field_type = jQuery(input_el).prop('tagName').toLowerCase(); // Use tag name for type
            var field_required = jQuery(input_el).attr('required') !== undefined; // Check if required attribute exists
            var field_input_type = jQuery(input_el).attr('type');
        
            var field_value:any = jQuery(input_el).val();
            if (field_input_type == "radio" || field_input_type == "checkbox") {
                field_value = jQuery(`${PlatformRegisterDeprecated.register_form_id} [data-section="${section_id}"] [name='${field_name}']:checked`).val();
                field_name = field_name.replace(/\[\]/g, '');
            }
        
            if (field_type == "select" && field_value === "-") {
                field_value = "";
            }
        
            // makesure value does not have whitespaces
            if (typeof(field_value) == "string") {
                field_value = field_value.trim();
            }
        
            field_sections[field_name] = {
                name: field_name,
                type: field_type,
                input_type: field_input_type,
                required: field_required,
                value: field_value
            }
        });

        return field_sections;
    }

    set_error = ( section_id:string, field_name:string, error:string='', toggle:boolean=true ) => {
        var field_error = jQuery( `${PlatformRegisterDeprecated.register_form_id} [data-section="${section_id}"] [data-vm-field-error='${field_name}']` );        
        var field = jQuery( `${PlatformRegisterDeprecated.register_form_id} [data-section="${section_id}"] [name='${field_name}']` );

        if (field && field_error) {
            field.removeClass("has--error");
            field_error.text('');
            if (toggle) {
                field.addClass("has--error");
                field_error.text(error);
            }
        }
    }

    set_required = ( section_id:string, field_sections:fieldArr={} ) => {
        if( field_sections ) {
            for( const key in field_sections ) {
                if( field_sections.hasOwnProperty(key) ) {
                    const field = field_sections[key];
                    if( field.required && (
                        ( field.value !== undefined && field.value.length === 0 ) || field.value === undefined
                    ) ) {
                        this.set_error( section_id, field.name, 'Field Required', true );
                    } else {
                        this.set_error( section_id, field.name, '', false );

                        if( field.required ) {
                            if (field.input_type === 'email') {
                                if( !validator.isEmail( field.value ) ) {
                                    this.set_error( section_id, field.name, 'Invalid Email', true );
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    is_valid = ( field_sections:fieldArr={} ) => {
        var _valid = true;

        if( field_sections ) {
            for( const key in field_sections ) {
                if( field_sections.hasOwnProperty(key) ) {
                    const field = field_sections[key];
                    if( field.required && 
                        ((field.value != undefined && field.value.length === 0) || field.value == undefined) ) {
                        // invalid
                        _valid = false;
                    } else {
                        if( field.required ) {
                            if (field.input_type === 'email') {
                                if( !validator.isEmail( field.value ) ) {
                                    _valid = false;
                                }
                            }
                        }
                    }
                }
            }
        }

        return _valid;
    }

    match_valid = ( field_sections:fieldArr={}, field_1:string='', field_2:string='' ) => {
        if( field_sections ) {
            if( field_sections.hasOwnProperty(field_1) && field_sections.hasOwnProperty(field_2) ) {
                return ( field_sections[field_1].value == field_sections[field_2].value );
            }
        }
        return false;
    }

    get_value = (field_sections:fieldArr={}, field:string) => {
        if( field_sections ) {
            if( field_sections.hasOwnProperty(field)) {
                return field_sections[field].value;
            }
        }
        return "";
    }

    validate = async (section_id:string) => {
        var field_sections: fieldArr = this.get_field_data(section_id);

        // if not completed :: set as required
        this.set_required(section_id, field_sections);
        var form_valid = this.is_valid( field_sections );
        if( !form_valid ) return form_valid;

        if (section_id === 'primary_section') {
            if( !form_valid ) return form_valid;

            // match validate email
            if( !this.match_valid( field_sections, 'str_email', 'str_email_conf' ) ) {
                this.set_error( section_id, 'str_email', '', true );
                this.set_error( section_id, 'str_email_conf', 'Email does not match', true );
                form_valid = false;
            }

            if( !this.match_valid( field_sections, 'reg_password', 'str_password_conf' ) ) {
                this.set_error( section_id, 'reg_password', '', true );
                this.set_error( section_id, 'str_password_conf', 'Password does not match', true );
                form_valid = false;
            }

            // email already exists check
            var emailFormData:FormData = new FormData();
            emailFormData.append( "action", "vm_email_exists" );
            emailFormData.append( "str_email", this.get_value(field_sections, "str_email") );

            const response = await fetch( register_localize.admin_ajax, {
                method: 'POST',
                credentials: 'same-origin',
                body: emailFormData,
            } );

            const data = await response.json();
            if( data && data.hasOwnProperty('success') ) {
                if( data.success && data.email_exists ) {
                    form_valid = false;
                    this.set_error( section_id, 'str_email', 'Email already exists. Please login to proceed!', true );
                    this.set_error( section_id, 'str_email_conf', '', true );
                }
                if( data.success && !data.valid_email ) {
                    form_valid = false;
                    this.set_error( section_id, 'str_email', 'Invalid field', true );
                    this.set_error( section_id, 'str_email_conf', '', true );
                }
            } else {
                // for any other condition form invalid
                form_valid = false;
            }

            return form_valid;
        }

        return form_valid;
    }
}

jQuery( document ).ready(function($:any) {
    var register = new PlatformRegisterDeprecated();
    if( jQuery(PlatformRegisterDeprecated.register_form_id) ) {
        register.init();
    }
});